import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `app1/webhook-config/${path}`;

export function fetchPresets() {
  return defaultClient.request({ url: URL('presets/') });
}

export function listWebhookConfigs(clientSlug) {
  return defaultClient.request({ url: URL(`${clientSlug}/`) });
}

export function createWebhookConfig(clientSlug, payload) {
  return defaultClient.request({ url: URL(`${clientSlug}/`), method: 'POST', payload });
}

export function updateWebhookConfig(clientSlug, id, payload) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/`), method: 'PATCH', payload });
}

export function deleteWebhookConfig(clientSlug, id) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/`), method: 'DELETE' });
}

export function testWebhookConfig(clientSlug, id, payload = {}) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/test/`), method: 'POST', payload });
}

export function listArchivedWebhookConfigs(clientSlug) {
  return defaultClient.request({ url: URL(`${clientSlug}/?mode=archived`) });
}

export function promoteWebhookConfig(clientSlug, id) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/promote/`), method: 'POST' });
}

export function testAuthWebhookConfig(clientSlug, id) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/test-auth/`), method: 'POST' });
}
